import React from 'react';
import PropTypes from 'prop-types';
import currencyFormatter from 'currency-formatter';
import styles from './CustomTooltip.pcss';

export default class CustomTooltip extends React.Component {
    static propTypes = {
        isCurrency: PropTypes.bool,
        active: PropTypes.bool,
        payload: PropTypes.array
    };

    render() {
        const {isCurrency, active, payload} = this.props;
        const value = payload && payload[0] && payload[0].value;
        if (active) {
            return (
                <div className={styles.tooltip}>
                    <p className="label">
                        {isCurrency ? currencyFormatter.format(value, {code: 'USD'}) : value}
                    </p>
                </div>
            );
        }
        return null;
    }
}
